const getMaskedCurrency = (currency: string): string => {
  if (currency === 'USD') return 'USDC';
  if (currency === 'EUR') return 'EURC';

  return currency;
};

export const getUnmaskedCurrency = (currency: string): string => {
  if (currency === 'USDC') return 'USD';
  if (currency === 'EURC') return 'EUR';

  return currency;
};

export default getMaskedCurrency;
